import React from "react";
import { PageSection } from "../common/pageSection/PageSection";
import { FaqSection } from "../../graphql/schema";
import {
  makeStyles,
  tokens,
  shorthands,
  Text,
  mergeClasses,
} from "@fluentui/react-components";
import { ChevronDownRegular, ChevronUpRegular } from "@fluentui/react-icons";
import { RichText } from "../../helper/richTextHelper";

const useStyles = makeStyles({
  wrapper: {
    minHeight: "1000px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    maxWidth: "1000px",
    ...shorthands.margin(0, "auto"),
    rowGap: tokens.spacingVerticalM,
    color: tokens.colorBrandBackground,
  },
  header: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalL,
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalXL),
    ...shorthands.borderRadius("20px"),
    backgroundColor: "#C9E3FF",
    cursor: "pointer",
  },
  headerExpanded: {
    ...shorthands.borderRadius("20px", "20px", 0, 0),
  },
  headerMinimized: {
    ...shorthands.borderRadius("20px"),
  },
  body: {
    ...shorthands.padding(
      tokens.spacingVerticalL,
      tokens.spacingHorizontalXXXL
    ),
    ...shorthands.borderRadius(0, 0, "20px", "20px"),
    backgroundColor: "#FFFFFF",
  },
  chevron: {
    fontSize: "24px",
  },
});

type QuestionAnswersProps = {
  faqSection: FaqSection;
};
export const QuestionAnswers = ({ faqSection }: QuestionAnswersProps): JSX.Element => {
  const classes = useStyles();
  const [expandedIndexes, setExpandedIndexes] = React.useState<number[]>([]);

  const handleToggle = (index: number) => {
    setExpandedIndexes(
      expandedIndexes.includes(index)
        ? expandedIndexes.filter((i) => i !== index)
        : [...expandedIndexes, index]
    );
  };

  return (
    <PageSection>
      <div className={classes.wrapper}>
        {faqSection.content?.map((block, index) => {
          if (!block || block.__typename !== "ComponentFaqQuestionAnswer") return null;

          return (
            <article key={index}>
              <div
                onClick={() => handleToggle(index)}
                className={mergeClasses(
                  classes.header,
                  expandedIndexes.includes(index)
                    ? classes.headerExpanded
                    : classes.headerMinimized
                )}
              >
                {expandedIndexes.includes(index) ? (
                  <ChevronUpRegular className={classes.chevron} />
                ) : (
                  <ChevronDownRegular className={classes.chevron} />
                )}
                <Text size={500} weight="semibold">
                  {block.question}
                </Text>
              </div>
              {expandedIndexes.includes(index) ? (
                <div className={classes.body}>
                  <RichText blocks={block.answer} />
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </PageSection>
  );
};
